import "../stylesheets/homepage";
import "../controllers"
import "@fortawesome/fontawesome-free/css/all.css";

import $ from "jquery";
window.$ = window.jQuery = $;

import Rails from '@rails/ujs'
Rails.start()
window.Rails = Rails

import "animate.css"
import "@popperjs/core";
import 'bootstrap/dist/js/bootstrap';
import Swal from 'sweetalert2';
window.Swal = Swal;
